import React from "react";
import { ClinicContext, ThemeContext } from "contexts";
import NormalText from "./NormalText";
import { hexToRgba } from "utils/hexToRgba";

type TitleBarAIHelperProps = {
  disableBackButton?: boolean;
  onClickBackButton: (() => void) | null;
  backButton?: React.ReactNode;
};

const TitleBarAIHelper: React.FC<TitleBarAIHelperProps> = ({
  onClickBackButton,
  disableBackButton = false,
  backButton = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6L9 12L15 18"
        stroke="#282B33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}) => {
  const theme = React.useContext(ThemeContext);
  const clinic = React.useContext(ClinicContext);

  return (
    <div
      style={{
        background: hexToRgba(theme?.themeColor ?? "#00B7F4", 0.1),
        ...styles.container,
      }}
    >
      <button
        disabled={disableBackButton || !onClickBackButton}
        style={{
          ...styles.backButton,
          cursor: !onClickBackButton
            ? "default"
            : disableBackButton
              ? "not-allowed"
              : "pointer",
          opacity: !onClickBackButton ? 0 : disableBackButton ? 0.5 : 1,
        }}
        onClick={(e) => {
          e.preventDefault();
          if (onClickBackButton) onClickBackButton();
        }}
      >
        {backButton}
      </button>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {clinic?.logo_url ? (
          <img src={clinic?.logo_url} alt="" style={styles.logo} />
        ) : (
          <NormalText
            textContent={`${clinic?.clinic_name} AI`}
            style={{
              fontWeight: "bold",
              fontSize: 20,
              textTransform: "capitalize",
            }}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
    height: 50,
    borderRadius: "0px 0px 15px 0px",
  },
  backButton: {
    position: "absolute",
    top: 15,
    left: 9,
    border: "none",
    backgroundColor: "transparent",
  },
  logo: {
    width: "100%",
    height: 40,
    cursor: "pointer",
    objectFit: "contain",
    margin: "0 auto",
  },
} as const;

export default TitleBarAIHelper;
